import React, { type FC } from 'react'

import classes from './LiveStreamThumbnail.module.scss'

type LiveStreamThumbnailProps = {
  imgSrc: string
}

export const LiveStreamThumbnail: FC<LiveStreamThumbnailProps> = ({
  imgSrc
}) => {
  return (
    <div
      className={classes.Thumbnail}
      style={{ backgroundImage: `url(${imgSrc})` }}
    />
  )
}
